import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/frontend/src/components/NotificationsGrid/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/frontend/src/providers/nextAuth.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/frontend/src/providers/reactQuery.provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/frontend/src/styles/global.css");
